import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common/Button';
import { EsitoLoginFinestra } from '@/components/common/EsitoLoginFinestra';
import { useHaptics } from '@/hooks/useHaptics';
import { useRichiedeAccesso, useSceltaOspite } from '@/hooks/useOspite';

/**
 * Il BENVENUTO dell'ospite: la prima schermata di chi apre la Mini App senza sessione, con
 * l'interruttore dell'ospite acceso. Sostituisce `<Login />` SOLO li': a interruttore spento (la
 * produzione) `AppShell` rende `<Login />` come sempre.
 *
 * [D Luca, 2026-09-25 ~23:2xZ, via tma-orcb: «C1 (b)»] — due scelte:
 *  · «Accedi»: lo stesso login di sempre (`useRichiedeAccesso`: bridge nel browser di sistema
 *    dentro Telegram), e se si era arrivati su una schermata precisa ci si torna dopo;
 *  · «Entra come ospite»: si entra, e la scelta si RICORDA (`useSceltaOspite`) — non si ripropone a
 *    ogni apertura; dal Profilo ospite la si puo' rivedere.
 *
 * ⚠️ Scelta di forma, dichiarata (facile da invertire): «Accedi» e' il bottone PRIMARIO perche' e'
 * l'azione che apre tutta l'app; l'ospite e' il secondo, un tocco piu' in la'.
 * ⛔ Niente «Show debug log»: era in `<Login />`, visibile a chiunque. Qui non c'e'.
 */
export function Benvenuto() {
  const { t } = useTranslation('general');
  const haptics = useHaptics();
  const richiedi = useRichiedeAccesso();
  const { entra } = useSceltaOspite();

  return (
    <div
      data-testid="ospite-benvenuto"
      className="flex min-h-screen flex-col items-center justify-center gap-8 bg-bg p-6 text-text"
    >
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <h1 className="text-4xl font-bold tracking-tight text-brand">QLASH</h1>
        <p className="text-base font-semibold text-fg">{t('ospite.benvenuto.titolo')}</p>
        <p className="text-sm text-fg-muted">{t('ospite.benvenuto.corpo')}</p>
      </div>

      <div className="flex w-full max-w-xs flex-col gap-3">
        <Button
          className="w-full px-6 py-3 text-base"
          onClick={() => {
            haptics.impact('light');
            richiedi();
          }}
        >
          {t('ospite.benvenuto.accedi')}
        </Button>
        {import.meta.env.VITE_FEATURE_LOGIN_FINESTRA_ENABLED === 'true' ? <EsitoLoginFinestra /> : null}
        <Button
          variant="secondary"
          className="w-full px-6 py-3 text-base"
          onClick={() => {
            haptics.impact('light');
            entra();
          }}
        >
          {t('ospite.benvenuto.entra')}
        </Button>
      </div>
    </div>
  );
}
